module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo07-nikon-acfabc0c7f6cfaace5aad7e0e0c7fe0c.jpg";